/**
 * Generated by orval 🍺
 * Do not edit manually.
 * fleetster
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CreateSessionDto,
  ErrorEnvelope,
  SessionResponseDto
} from '../../models';





const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const authControllerCreateSession = (
    createSessionDto: CreateSessionDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SessionResponseDto>> => {


    return axios.post(
      `/api/auth/session`,
      createSessionDto,options
    );
  }

export const getAuthControllerCreateSessionUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/auth/session`,
    baseURL: '',


  });
}




export const getAuthControllerCreateSessionMutationKey = () => ['authControllerCreateSession'] as const;

export const getAuthControllerCreateSessionMutationOptions = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateSession>>, TError,AuthControllerCreateSessionMutationVariables, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateSession>>, TError,AuthControllerCreateSessionMutationVariables, TContext> => {

const mutationKey = getAuthControllerCreateSessionMutationKey();
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerCreateSession>>, AuthControllerCreateSessionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerCreateSession(data,axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerCreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerCreateSession>>>
    export type AuthControllerCreateSessionMutationBody = CreateSessionDto
    export type AuthControllerCreateSessionMutationError = AxiosError<ErrorEnvelope>
    export type AuthControllerCreateSessionMutationVariables = {data: CreateSessionDto}

    export const useAuthControllerCreateSession = <TError = AxiosError<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerCreateSession>>, TError,AuthControllerCreateSessionMutationVariables, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerCreateSession>>,
        TError,
        AuthControllerCreateSessionMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerCreateSessionMutationOptions(options), queryClient);
    }
    export const authControllerGetSession = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SessionResponseDto>> => {


    return axios.get(
      `/api/auth/session`,options
    );
  }

export const getAuthControllerGetSessionUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/auth/session`,
    baseURL: '',


  });
}




export const getAuthControllerGetSessionQueryKey = () => {
    return [
    `/api/auth/session`
    ] as const;
    }


export const getAuthControllerGetSessionQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetSession>>, TError = AxiosError<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetSessionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetSession>>> = ({ signal }) => authControllerGetSession({ signal, ...axiosOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerGetSessionQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetSession>>>
export type AuthControllerGetSessionQueryError = AxiosError<ErrorEnvelope>


export function useAuthControllerGetSession<TData = Awaited<ReturnType<typeof authControllerGetSession>>, TError = AxiosError<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetSession>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetSession>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGetSession<TData = Awaited<ReturnType<typeof authControllerGetSession>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetSession>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetSession>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerGetSession<TData = Awaited<ReturnType<typeof authControllerGetSession>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerGetSession<TData = Awaited<ReturnType<typeof authControllerGetSession>>, TError = AxiosError<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetSession>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthControllerGetSessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const authControllerDeleteSession = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {


    return axios.delete(
      `/api/auth/session`,options
    );
  }

export const getAuthControllerDeleteSessionUrl = () => {

  return axios.create({
    baseURL: '',
    params: null,
  }).getUri({
    url: `/api/auth/session`,
    baseURL: '',


  });
}




export const getAuthControllerDeleteSessionMutationKey = () => ['authControllerDeleteSession'] as const;

export const getAuthControllerDeleteSessionMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerDeleteSession>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerDeleteSession>>, TError,void, TContext> => {

const mutationKey = getAuthControllerDeleteSessionMutationKey();
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerDeleteSession>>, void> = () => {


          return  authControllerDeleteSession(axiosOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerDeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerDeleteSession>>>

    export type AuthControllerDeleteSessionMutationError = AxiosError<unknown>


    export const useAuthControllerDeleteSession = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerDeleteSession>>, TError,void, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerDeleteSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerDeleteSessionMutationOptions(options), queryClient);
    }
